import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";


interface SidebarState {
  sidebarStatus: boolean,
  type: string | null
}

// No mobile o menu expandido e uma gaveta por cima do conteudo — abrir o app
// nesse estado esconde a propria tela que a pessoa veio ver. No desktop ele
// convive com o conteudo, entao continua aberto por padrao.
const startsCollapsed =
  typeof window !== 'undefined' && window.matchMedia('(max-width: 760px)').matches;

const initialState: SidebarState = {
  sidebarStatus: !startsCollapsed,
  type: 'admin'
};

const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        setSidebarStatus: (state, action: PayloadAction<boolean>) => {
            state.sidebarStatus = action.payload;
        },
    }
  });
  
export const {setSidebarStatus} = sidebarSlice.actions;


// customs func
export const getSidebarStatus = (state: RootState): boolean => state.sidebar.sidebarStatus;

export default sidebarSlice.reducer;